import React, { useState } from 'react';
import { FiSend, FiMail, FiPhone, FiMapPin, FiCheckCircle, FiAlertCircle } from 'react-icons/fi';
import axios from 'axios';

function Contato() {
  const [formData, setFormData] = useState({
    nome: '',
    email: '',
    telefone: '',
    assunto: '',
    mensagem: ''
  });
  const [status, setStatus] = useState({ type: '', message: '' });
  const [loading, setLoading] = useState(false);

  // URL correta da API
  const apiUrl = process.env.REACT_APP_API_URL || 'http://localhost:5000/api';

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
    
    // Limpa erro quando usuário digita
    if (status.type === 'error') {
      setStatus({ type: '', message: '' });
    }
  };

  const validateForm = () => {
    if (!formData.nome.trim() || !formData.email.trim() || !formData.mensagem.trim()) {
      setStatus({
        type: 'error',
        message: 'Por favor, preencha todos os campos obrigatórios (*)'
      });
      return false;
    }

    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(formData.email)) {
      setStatus({
        type: 'error',
        message: 'Por favor, insira um email válido'
      });
      return false;
    }

    return true;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    if (!validateForm()) return;

    setLoading(true);
    setStatus({ type: '', message: '' });

    try {
      const response = await axios.post(`${apiUrl}/contato`, formData, {
        headers: {
          'Content-Type': 'application/json'
        },
        timeout: 30000 // 10 segundos timeout
      });

      setStatus({
        type: 'success',
        message: response.data.message || 'Mensagem enviada com sucesso! Entraremos em contato em breve.'
      });
      
      // Limpa formulário
      setFormData({ 
        nome: '', 
        email: '', 
        telefone: '', 
        assunto: '', 
        mensagem: '' 
      });

    } catch (error) {
      console.error('Erro ao enviar:', error);
      
      let errorMessage = 'Erro ao enviar mensagem. Tente novamente.';
      
      if (error.response) {
        // Erro da API
        errorMessage = error.response.data?.error || errorMessage;
      } else if (error.request) {
        // Sem resposta do servidor
        errorMessage = 'Servidor indisponível. Verifique sua conexão.';
      }

      setStatus({
        type: 'error',
        message: errorMessage
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <section id="contato" className="contato-section">
      <div className="contato-container">
        <div className="section-title">
          <h2>Vamos Conversar</h2>
          <p>Pronto para transformar sua ideia em realidade?</p>
        </div>

        <div className="contato-grid">
          {/* Lado Esquerdo - Informações */}
          <div className="contato-info">
            <h3>Informações de Contato</h3>
            
            <div className="info-lista">
              <div className="info-item">
                <div className="info-icon">
                  <FiMail size={20} />
                </div>
                <div className="info-texto">
                  <span className="info-label">Email</span>
                  <span className="info-valor">contato@onlinup.com</span>
                </div>
              </div>

              <a 
  href="https://wa.me/+5531971258912"
  target="_blank"
  rel="noopener noreferrer"
  className="info-item whatsapp-link"
>
  <div className="info-icon">
    <FiPhone size={20} />
  </div>
  <div className="info-texto">
    <span className="info-label">WhatsApp</span>
    <span className="info-valor">(31) 97125-8912</span>
  </div>
</a>
              <div className="info-item">
                <div className="info-icon">
                  <FiMapPin size={20} />
                </div>
                <div className="info-texto">
                  <span className="info-label">Localização</span>
                  <span className="info-valor">Dona Francisca, RS - Remoto</span>
                </div>
              </div>
            </div>
          </div>

          {/* Lado Direito - Formulário */}
          <form onSubmit={handleSubmit} className="contato-form" noValidate>
            {status.message && (
              <div className={`alert alert-${status.type}`}>
                {status.type === 'success' ? <FiCheckCircle /> : <FiAlertCircle />}
                <span>{status.message}</span>
              </div>
            )}

            <div className="form-group">
              <label htmlFor="nome">Nome *</label>
              <input
                type="text"
                id="nome"
                name="nome"
                value={formData.nome}
                onChange={handleChange}
                required
                placeholder="Seu nome completo"
                disabled={loading}
              />
            </div>

            <div className="form-row">
              <div className="form-group">
                <label htmlFor="email">Email *</label>
                <input
                  type="email"
                  id="email"
                  name="email"
                  value={formData.email}
                  onChange={handleChange}
                  required
                  placeholder="seu@email.com"
                  disabled={loading}
                />
              </div>
              <div className="form-group">
                <label htmlFor="telefone">Telefone</label>
                <input
                  type="tel"
                  id="telefone"
                  name="telefone"
                  value={formData.telefone}
                  onChange={handleChange}
                  placeholder="(11) 99999-9999"
                  disabled={loading}
                />
              </div>
            </div>

            <div className="form-group">
              <label htmlFor="assunto">Assunto</label>
              <input
                type="text"
                id="assunto"
                name="assunto"
                value={formData.assunto}
                onChange={handleChange}
                placeholder="Qual o assunto?"
                disabled={loading}
              />
            </div>

            <div className="form-group">
              <label htmlFor="mensagem">Mensagem *</label>
              <textarea
                id="mensagem"
                name="mensagem"
                value={formData.mensagem}
                onChange={handleChange}
                required
                placeholder="Conte-me sobre seu projeto..."
                rows="4"
                disabled={loading}
              />
            </div>

            <button 
              type="submit" 
              className="btn btn-primary btn-contato" 
              disabled={loading}
            >
              {loading ? (
                <>
                  <span className="spinner"></span>
                  Enviando...
                </>
              ) : (
                <>
                  Enviar Mensagem
                  <FiSend />
                </>
              )}
            </button>
          </form>
        </div>
      </div>
    </section>
  );
}

export default Contato;